import { FlowConsumerContextEnergy as FlowContext } from '../../context';

export const shouldSkipWhenNoRentalDeviceCrossSellProductAvailable = (context: FlowContext): boolean => {
  const { isRentalDeviceCrossSellProductAvailable } = context;

  return !isRentalDeviceCrossSellProductAvailable;
};
